import { Pipe, PipeTransform } from '@angular/core';
import {SafeUrl, DomSanitizer} from "@angular/platform-browser";

@Pipe({
    name: 'trustedUrl',
    standalone: false
})
export class TrustedUrlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
